import config from "../config.json";
import { apiClient, getAccessToken, getUserEmail } from "./apiClient";

const SearchMessenger = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();
    let paramCount = 0;

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value != null && value !== undefined) {
            params.append(key, value);
            paramCount++;
        }
    });

    let url = `${config.API_URL}/messengers/search`;

    if (paramCount > 0) {
        url += `?${params.toString()}`;
    }

    let headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, {
            headers,
            timeout: config.API_CONNECTION_TIMEOUT,
        });
    } catch (error) {
        throw error;
    }
};

const CreateMessenger = async (req) => {
  const token = await getAccessToken();
  let url = `${config.API_URL}/messengers`;

  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  
  try {
    return await apiClient.post(url, JSON.stringify(req), {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    throw error;
  }
};

const UpdateMessenger = async (id, req) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/messengers/${id}`;

    let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.put(url, JSON.stringify(req), {
            headers,
            timeout: config.API_CONNECTION_TIMEOUT,
        });
    } catch (error) {
        throw error;
    }
};

const DeleteMessenger = async (id) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/messengers/${id}`;
    let req = {
        status: 0
    };

    let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        User: getUserEmail(),
    };

    try {
        return await apiClient.patch(url, JSON.stringify(req), {
            headers,
            timeout: config.API_CONNECTION_TIMEOUT,
        });
    } catch (error) {
        throw error;
    }
};

const GetMessengerById = async (id) => {
    const token = await getAccessToken();
    let url = `${config.API_URL}/messengers/${id}`;

    let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, {
            headers,
            timeout: config.API_CONNECTION_TIMEOUT,
        });
    } catch (error) {
        throw error;
    }
};

const MessengerService = {
    SearchMessenger,
    CreateMessenger,
    UpdateMessenger,
    DeleteMessenger,
    GetMessengerById,
};

export default MessengerService;
